document.addEventListener('DOMContentLoaded', () => {
          const tabBar = document.querySelector('.community-tabs');
          if (!tabBar) return;

          const tabButtons = Array.from(tabBar.querySelectorAll('.--tab-btn'));
          if (!tabButtons.length) return;

          const header = document.querySelector('store-header.header, .header, header');
          const getHeaderHeight = () => header ? header.offsetHeight : 0;

          const sections = tabButtons
            .map((button) => {
              const href = button.getAttribute('href') || '';
              if (!href.startsWith('#')) return null;
              return document.getElementById(href.slice(1));
            })
            .filter(Boolean);

          const centerActiveButton = (activeButton) => {
            if (!activeButton) return;
            const buttonRect = activeButton.getBoundingClientRect();
            const barRect = tabBar.getBoundingClientRect();
            const offset = buttonRect.left - barRect.left - (barRect.width / 2) + (buttonRect.width / 2);
            const maxScroll = tabBar.scrollWidth - tabBar.clientWidth;
            const scrollLeft = Math.max(0, Math.min(tabBar.scrollLeft + offset, maxScroll));
            tabBar.scrollTo({ left: scrollLeft, behavior: 'smooth' });
          };

          const setActiveButton = (targetId) => {
            let activeButton = null;
            tabButtons.forEach((button) => {
              const isActive = button.getAttribute('href') === `#${targetId}`;
              button.classList.toggle('active', isActive);
              if (isActive) activeButton = button;
            });
            centerActiveButton(activeButton);
          };

          const scrollToSection = (targetId) => {
            const section = document.getElementById(targetId);
            if (!section) return;
            const offset = getHeaderHeight() + 58;
            const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: 'smooth' });
          };

          let isScrollingByClick = false;
          const throttle = (fn) => {
            let ticking = false;
            return (...args) => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                fn(...args);
                ticking = false;
              });
            };
          };

          tabButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              const href = button.getAttribute('href') || '';
              if (!href.startsWith('#')) return;

              const targetId = href.slice(1);
              setActiveButton(targetId);
              isScrollingByClick = true;
              scrollToSection(targetId);
              window.setTimeout(() => {
                isScrollingByClick = false;
              }, 600);
            });
          });

          const updateActiveOnScroll = () => {
            if (isScrollingByClick) return;
            let closest = null;
            let minDistance = Number.POSITIVE_INFINITY;
            const offset = getHeaderHeight() + 20;

            sections.forEach((section) => {
              const rect = section.getBoundingClientRect();
              const distance = Math.abs(rect.top - offset);
              if (distance < minDistance) {
                minDistance = distance;
                closest = section;
              }
            });

            if (closest) {
              setActiveButton(closest.id);
            }
          };

          window.addEventListener('scroll', throttle(updateActiveOnScroll), { passive: true });
          window.addEventListener('resize', throttle(updateActiveOnScroll));

          updateActiveOnScroll();
        });